import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "What is engraving-grade phenolic?",
  answerStart: "Engraving-grade phenolic is a layered thermoset laminate with a colored cap over a contrasting core; engraving exposes the core to create permanent two-color text. Evermark Industrial Solutions engraves it for control-panel and MIL-SPEC identification.",
  linkText: "",
  linkUrl: "",
  answerEnd: ""
}, {
  question: "What is the dielectric strength of phenolic?",
  answerStart: "Phenolic is valued for high dielectric strength, which is why it is specified for control-panel identification; the specific rating for Evermark Industrial Solutions' engraving-grade phenolic is {{verify: dielectric strength value}} — confirm against the material datasheet for a given application.",
  linkText: "",
  linkUrl: "",
  answerEnd: ""
}, {
  question: "What thicknesses and colors does phenolic come in?",
  answerStart: "Evermark Industrial Solutions engraves phenolic in standard nameplate thicknesses ({{verify: thickness list}}) and common two-color combinations such as white-on-black and black-on-white; the full stock list is confirmed at quote.",
  linkText: "",
  linkUrl: "",
  answerEnd: ""
}, {
  question: "Does phenolic meet MIL-SPEC requirements?",
  answerStart: "Evermark Industrial Solutions engraves phenolic designed to align with MIL-SPEC nameplate standards such as MIL-DTL-15024 and MIL-P-15035 when properly specified; the required type and grade, and certificate-of-conformance availability, are confirmed per project — see {{verify: MIL-SPEC types and CoC}}.",
  linkText: "",
  linkUrl: "",
  answerEnd: ""
}, {
  question: "When should I choose phenolic instead of acrylic?",
  answerStart: "Evermark Industrial Solutions recommends phenolic where dielectric strength, higher temperature tolerance, or MIL-SPEC compliance is required, and two-color acrylic where a wider color range or faster lead time matters; the ",
  linkText: "comparison guide",
  linkUrl: "/resources/guides/phenolic-vs-acrylic-engraving/",
  answerEnd: " covers the trade-offs."
}];
export default function FaqAccordion() {
  return <section id="faqaccordion" className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-10 text-center">
          Phenolic Engraving Material — Common Questions
        </h2>
        
        <div className="bg-background rounded-lg shadow-sm border border-border p-4 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-base md:text-lg font-semibold font-default text-left hover:text-primary transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6">
                  {faq.answerStart}
                  {faq.linkUrl && <Link to={faq.linkUrl} className="text-primary hover:underline font-medium">
                      {faq.linkText}
                    </Link>}
                  {faq.answerEnd}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}